import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { MdPrint } from 'react-icons/lib/md';
import { formatDate } from '../../utils/';
import { formatMoney } from '../../utils/budget';
import GMapInfrastructure from '../detail/GMapInfrastructure';

class FactSheetViewFormInfra extends React.Component {

    constructor(props) {
        super(props);
        this.printBtn = this.printBtn.bind(this);
        this.getMemberNameByTitle = this.getMemberNameByTitle.bind(this);
        this.getConsTotalCommitedAmount = this.getConsTotalCommitedAmount.bind(this);
        this.getContractorVendor = this.getContractorVendor.bind(this);
        this.getREIServicesVendor = this.getREIServicesVendor.bind(this);
        this.getDesignConsultant = this.getDesignConsultant.bind(this);
    }

    printBtn() {
        window.print();
    }

    getMemberNameByTitle(title) {
        const { members } = this.props;
        let value = '';
        members.forEach((item) => {
            if (item.projectTitle.title === title) {
                if (value === '') {
                    value = `${item.member.firstName} ${item.member.lastName}`;
                } else {
                    value = `${value}, ${item.member.firstName} ${item.member.lastName} `
                }
            }
        })
        return value;
    }
    getConsTotalCommitedAmount() {
        const { budgets, factSheet } = this.props;
        if (factSheet.budgetConstruction) {
            return factSheet.budgetConstruction;
        }
        else {
            let totalCommitedAmount = 0;
            for (const element of budgets) {
                element.budget.forEach(item => {
                    if (item.pObject === 'CONS') {
                        totalCommitedAmount = totalCommitedAmount + item.committedAmount
                    }
                })
            }
            return totalCommitedAmount !== 0 ? totalCommitedAmount : null;
        }
    }

    getContractorVendor() {
        const list = this.props.contracts.filter(item => item.contractType.includes("Construction/Regular"));
        const contractorList = [];
        if (list.length > 0) {
            list.forEach((s) => {
                contractorList.push(s.contractor)
            })

        }
        return contractorList;
    }

    getREIServicesVendor() {
        const list = this.props.contracts.filter(item => item.contractType === "Professional/Requirements/Pure REI Manage/N/A" || item.contractType === "Professional/Pure REI Manage/N/A/N/A");
        const contractorList = [];
        if (list.length > 0) {
            list.forEach((s) => {
                contractorList.push(s.contractor)
            })

        }
        return contractorList;

    }

    getDesignConsultant() {
        const list = this.props.contracts.filter(item => item.contractType.includes("Design"));
        const contractorList = [];
        if (list.length > 0) {
            list.forEach((s) => {
                contractorList.push(s.contractor)
            })

        }
        return contractorList;
    }



    render() {
        const { factSheet, schedule, members, info, budgets, projectId } = this.props;

        const pmDirector = this.getMemberNameByTitle('PA – Borough Director');

        const constructionDirector = this.getMemberNameByTitle('Construction Borough Director');

        const engineerInCharge = this.getMemberNameByTitle('DDC Construction EIC');

        const residentEngineer = this.getMemberNameByTitle('DDC Resident Engineer (Construction)');

        const associateComissioner = this.getMemberNameByTitle('Associate commissioner ( Construction)')

        const designConsultant = this.getDesignConsultant();

        const reiServices = this.getREIServicesVendor();

        const contractor = this.getContractorVendor();


        const currentConstructionCost = this.getConsTotalCommitedAmount();

        return (
            <div className="fact-sheet print-fact-sheet">

                <div className="row no-print">
                    <div className="col l2 offset-l10 m2 offset-m10 s2 offset-s10">
                        <button onClick={() => this.printBtn()}>
                            <span><MdPrint size={30} color='#8492a6' /></span>
                        </button>
                    </div>
                </div>

                {factSheet.factSheetTitle != null && factSheet.factSheetTitle !== ''
                    ? <div className="row print-margin-top--3">
                        <h2 className="text-center">{factSheet.factSheetTitle}</h2>
                    </div>
                    : null}

                {info.fmsids.length > 0
                    ? <div className="row">
                        <div className="col s12">
                            <h4 className="text-center">{info.fmsids.join(', ')}</h4>
                        </div>
                    </div>
                    : null}

                <div className="row">
                    <div className="col l5 m6">
                        <div>

                            <div className="controls padding-top-0">
                                <span className="label span-inline">Sponsor Agency:</span>
                                {factSheet.clientAgency != null && factSheet.clientAgency !== ''
                                    ? <span className="value span-inline">{factSheet.clientAgency}</span> : null}
                            </div>
                        </div>


                        <div className="controls">
                            <span className="label span-inline">Commissioner:</span>
                            <span className="value span-inline">{factSheet.comissioner ?? 'Thomas Foley'}</span>
                        </div>



                        <div className="controls margin-bottom-15">
                            <span className="label span-inline">First Deputy Commissioner:</span>
                            <span className="value span-inline">{factSheet.firstDeputyComissioner ?? 'Eric Macfarlene'}</span>
                        </div>

                        <div className="controls">
                            <span className="label span-inline">Associate Commissioner:</span>

                            {associateComissioner != ''
                                ? <span className="value span-inline">{associateComissioner}</span> : null}
                        </div>



                        <div className="controls margin-bottom-15">
                            <span className="label span-inline">Executive Director:</span>
                            <span className="value span-inline">{'Herve Carrie'}</span>
                        </div>


                        <div className="controls margin-bottom-15">
                            <span className="label span-inline">PM Director:</span>
                            {pmDirector !== ''
                                ? <span className="value span-inline">{pmDirector}</span> : null}

                        </div>


                        <div className="controls margin-bottom-15">
                            <span className="label span-inline">Construction Director:</span>
                            {constructionDirector !== ''
                                ? <span className="value span-inline">{constructionDirector}</span> : null}
                        </div>


                        <div className="controls margin-bottom-15">
                            <span className="label span-inline">Engineer On-Charge:</span>
                            {engineerInCharge !== ''
                                ? <span className="value span-inline">{engineerInCharge}</span> : null}
                        </div>


                        <div className="controls margin-bottom-15">
                            <span className="label span-inline">Resident Engineer:</span>
                            {residentEngineer !== ''
                                ? <span className="value span-inline">{residentEngineer}</span> : null}
                        </div>

                        <div className="controls margin-bottom-15">
                            <span className="label">Main Project Location:</span>
                            {factSheet.address1 != null && factSheet.address1 !== ''
                                ? <span className="value">{factSheet.address1}</span> : null}
                            {factSheet.address2 != null && factSheet.address2 !== ''
                                ? <span className="value">{factSheet.address2}</span> : null}
                            {factSheet.zipCode != null && factSheet.zipCode !== ''
                                ? <span className="value">{factSheet.zipCode} </span> : null}
                        </div>



                        <div className="controls margin-bottom-15">
                            <span className="label span-inline">Current Construction Cost:</span>
                            {currentConstructionCost != null && currentConstructionCost !== ''
                                ? <span className="value span-inline">{formatMoney(currentConstructionCost)}</span> : null}
                        </div>

                        <div className="controls margin-bottom-15">
                            <span className="label span-inline">REI Services:</span>
                            {reiServices.length > 0
                                ? reiServices.map((item, index) => {
                                    return <div key={index}><span className="value span-inline">{item}</span><br /> </div>
                                }) : null}
                        </div>

                        <div className="controls margin-bottom-15">
                            <span className="label span-inline">Design Consultant:</span>
                            {designConsultant.length > 0
                                ?
                                designConsultant.map((item, index) => {
                                    return <div key={index}><span className="value span-inline">{item}</span><br /> </div>
                                })
                                : null}
                        </div>


                        <div className="controls">
                            <span className="label span-inline">Contractors:</span>
                            {contractor.length > 0
                                ?
                                contractor.map((item, index) => {
                                    return <div key={index}><span className="value span-inline">{item}</span><br /> </div>
                                })
                                : null}
                        </div>



                        <div className="controls margin-bottom-15">
                            <span className="label">Contract Duration:</span>
                            {/* TBD dates */}

                            <div className="value">Notice to Proceed:  {schedule.designStart.actual !== null && schedule.designStart.actual !== '' ? formatDate(schedule.constructionStart.actual) : ''}</div>

                            <div className="value">Original Contract Completion Date:   {schedule.designStart.constructionBaseline !== null && schedule.designStart.constructionBaseline !== '' ? formatDate(schedule.constructionCompletion.constructionBaseline) : ''}</div>
                            <span className="value">Expected Completion Date:  {schedule.constructionCompletion.projected !== null && schedule.constructionCompletion.projected !== '' ? formatDate(schedule.constructionCompletion.projected) : ''}</span>
                            <span className="value">Actual Completion Date: {schedule.constructionCompletion.actual !== null && schedule.constructionCompletion.actual !== '' ? formatDate(schedule.constructionCompletion.actual) : ''}</span>

                        </div>


                    </div>

                    <div className="col l7 m6">
                        <div className="controls">
                            <span className="label">Title Content</span>
                            {factSheet.projectDescription != null && factSheet.projectDescription !== ''
                                ? <span className="textarea-custom text-new-roman">{factSheet.projectDescription}</span> : null}
                        </div>


                        <br />
                        <div className="controls">
                            <span className="label">Scope of Work</span>
                            {factSheet.scopeOfWork != null && factSheet.scopeOfWork !== ''
                                ? <pre className="textarea-custom text-new-roman"> {factSheet.scopeOfWork} </pre> : null}

                        </div>
                        <div className="controls"> <label>Project Area </label>
                            <GMapInfrastructure projectId={projectId} />


                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

FactSheetViewFormInfra.propTypes = {
    factSheet: PropTypes.object.isRequired,

};

export default (FactSheetViewFormInfra);